// extracted by mini-css-extract-plugin
export var drawerPaper = "_1p-0";
export var itemCard = "_1p-1";
export var itemImage = "_1p-2";